export default "__VITE_ASSET__B2t7sAax__"